import { Paper } from '@mui/material';
import UserStories from '../../../common/UserStories';
import TrendingWidget from '../../../common/SUHomepage/TrendingWidget';
import FooterV2 from '../../../common/FooterV2';

const DefaultWidget = ({ }) => {
    const userInformation = JSON.parse(localStorage.getItem('user'));

    if (userInformation) {
        return <>
            {/* <Paper
                elevation={3}
                sx={{ marginBottom: '12px' }}
            >
                <div className="suggested-creators-container user-story-wrapper mb-2">
                    <h3>Followed Creators Story</h3>
                    <UserStories />
                </div>
            </Paper> */}

            <Paper
                elevation={3}
                sx={{ marginBottom: '12px', marginTop: '-8px' }}  // added a -8px marginTop to move the rending widget up by 8px instead of removing the padding-top on every instances of this component's parent
            >
                <TrendingWidget />
            </Paper>

            <FooterV2 />
        </>;
    }

    return <>

        <Paper
            elevation={3}
            sx={{ marginBottom: '12px' }}
        >
            <TrendingWidget />
        </Paper>

        <FooterV2 />
    </>;
};

export default DefaultWidget;